// Global packages and components
import { Link } from '@remix-run/react'
import { Image, Picture } from '~/components'
import { getLinkType } from '~/utils'

// Types
import type { SanityLinkObject, SanityRefWithAlt } from '~/types'

interface Props {
  image?: SanityRefWithAlt
  mobileImage?: SanityRefWithAlt
  link?: SanityLinkObject
}

// Main export
export default function BlockImageInline({ image, mobileImage, link }: Props) {
  if (!image?.asset) return <div className="container" />

  // The picture markup, which swaps to the mobile image below 768px, is only
  // used when a mobile image is set, so blocks without one render as before
  const picture = mobileImage?.asset ? (
    <Picture
      image={image}
      imageMobile={mobileImage}
      classNamePic="block"
      classNameImg="block h-auto w-full rounded-2xl"
    />
  ) : (
    <Image
      image={image}
      className="h-auto w-full rounded-2xl"
    />
  )

  // An optional link wraps the image. External links open in a new tab, as
  // the Studio's link field says
  const url = getLinkType({ ...link })
  const isExternal = new RegExp('^(http|https|mailto|tel)://', 'i').test(url)

  return (
    <div className="container">
      {url && isExternal ? (
        <a
          href={url}
          target="_blank"
          rel="noreferrer"
          className="block"
        >
          {picture}
        </a>
      ) : url ? (
        <Link
          to={url}
          className="block"
        >
          {picture}
        </Link>
      ) : (
        picture
      )}
    </div>
  )
}
